import React from 'react';
import { Link } from 'react-router-dom';

export default function ConversationName({
  chat,
  currentUser,
  contacts,
  activeUser,
  getUserofGroupChat,
  isGroupChat = false,
}) {

  // Determine sender info depending on group or private chat
  const getSenderInfo = () => {
    const isCurrentUser = chat.sender === currentUser._id;
    
    if (isGroupChat) {
      const sender = isCurrentUser
        ? currentUser
        : getUserofGroupChat(contacts[activeUser]?.members, chat.sender);

      return {
        id: sender?._id,
        name: `${sender?.contactName?.first || ''} ${sender?.contactName?.last || ''}`.trim(),
        businessName: isCurrentUser
          ? currentUser?.accountNo?.companyInfo?.businessName
          : undefined,
        companyName: isCurrentUser
          ? currentUser?.accountNo?.companyInfo?.name
          : undefined,
      };
    } else {
      const contact = contacts[activeUser];
      console.log("isCurrentUser", contact);
      return {
        id: isCurrentUser ? currentUser._id : contact._id,
        name: isCurrentUser
          ? `${currentUser.contactName.first} ${currentUser.contactName.last}`
          : contact.name,
        businessName: isCurrentUser
          ? currentUser?.accountNo?.companyInfo?.businessName
          : contact.businessName,
        userFunction: isCurrentUser
          ? currentUser?.function
          : contact?.function,
        companyName: isCurrentUser
          ? currentUser?.user?.accountNo?.companyInfo?.name
          : contact?.user?.accountNo?.companyInfo?.name
      };
    }
  };

  const { id, name, userFunction, companyName } = getSenderInfo();

  return (
    <div className="conversation-name">
      {/* <Link to={`/user/profile/${id}`}>{name} {userFunction && `, ${userFunction}`}</Link> */}

      <Link to={`/user/profile/${id}`}>{name}</Link>
      <span> {userFunction}</span>
      <span> {companyName}</span>

      {/* Uncomment below to show businessName if needed */}
      {/* {businessName && <div className="business-name">{businessName}</div>} */}
    </div>
  );
}
